import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const MarketplaceAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.marketplace} />

export default MarketplaceAppDevelopment
